module.exports = __webpack_public_path__ + "img/lens-167-minus-12.6e20dee4.png";